import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { DeleteUserManagementReport } from "./../../../domain/useages/user-management/delete-user-management-report";
import { RemoteDeleteUserManagementReport } from "../../../data/usecases/user-management/remote-delete-user-management-report";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface DeleteUserManagementReportInterface {
  deleteUserManagementReport: Function;
}

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useDeleteUserManagementReportSlice: StateCreator<
  DeleteUserManagementReportInterface
> = (set, get) => ({
  deleteUserManagementReport: async (
    id: number,
    payload: DeleteUserManagementReport.Params,
    handleClose: Function
  ) => {
      const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
      const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteDeleteUserManagementReport =
      new RemoteDeleteUserManagementReport(
        `${BASE_URL}${Endpoints.DELETE_USER_MANAGEMENT_REPORT}`,
        axiosHttpClient
      );
    let result = await remoteDeleteUserManagementReport.delete(
      id.toString(),
      payload
    );

    if (result) {
      handleClose();
    }
  },
});
